const BASE_URL =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:4000";

export default BASE_URL;
